import React from "react";

function CheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="88"
      height="88"
      fill="none"
      viewBox="0 0 88 88"
    >
      <path
        fill="#00CE49"
        d="M44 0c24.3 0 44 19.7 44 44S68.3 88 44 88 0 68.3 0 44 19.7 0 44 0zm0 4C21.909 4 4 21.909 4 44s17.909 40 40 40 40-17.909 40-40S66.091 4 44 4zm18.478 28a2 2 0 01.034 2.828L40.607 57.274a3.001 3.001 0 01-4.196.096L25.095 46.792a2 2 0 112.732-2.922l10.6 9.909 21.222-21.745A2.002 2.002 0 0162.478 32z"
      ></path>
    </svg>
  );
}

export default CheckIcon;